"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toKnownErr = toKnownErr;
const lexicons_1 = require("../../../../lexicons");
const util_1 = require("../../../../util");
const is$typed = util_1.is$typed, validate = lexicons_1.validate;
const id = 'com.atproto.admin.updateAccountSigningKey';
function toKnownErr(e) {
    return e;
}
//# sourceMappingURL=updateAccountSigningKey.js.map